// extracted by mini-css-extract-plugin
export default {"footer":"VkMusicBundleLicenseNote__footer--2LV8j"};